import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiPencil, mdiPlus } from "@mdi/js";
import Trash from "Resources/ImagesNew/IconTable/trash.png";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item, index }) => {
  const [isModalClose, setModalClose] = useState(false);
  const CloseModal = () => {
    setModalClose(!isModalClose);
  };
  return (
    <>
      <a id={"btnXoaDonHang" + index} href={() => false} class="iconTable-Main" onClick={CloseModal}>
        <img src={Trash} title="Xoá" alt="" />
      </a>
      {isModalClose && <ModalXoa CloseModal={CloseModal} item={item} />}
    </>
  );
};
